import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

class ContractOpenBillsService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      bills: [],
    });
  }

  init = action(() => {
    this.bills = [];
  });

  load = action(async (contractId) => {
    const bills = await this.fetch.fetch({
      apiVersion: 'v2',
      url: `/contracts/${contractId}/overdue-bills`,
    });
    if (bills) {
      this.bills = bills;
    }
  });
}

export default ContractOpenBillsService;
